var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notaries__notes"},[_c('img',{attrs:{"src":require("@/assets/img/palacio.svg")}}),_c('span',[_vm._v("Un sitio oficial de Gobierno del Estado de Nuevo León")])])
}]

export { render, staticRenderFns }